module.exports = __webpack_public_path__ + "img/lb-svg.63045474.svg";